import type { RouteRecordRaw } from "vue-router";

export const searchRoutes: RouteRecordRaw[] = [
  {
    path: "/search",
    name: "search-index",
    component: () => import("./SearchPage.vue"),
    meta: {
      requiresAuth: true,
    },
  },
];
